import { NgModule } from '@angular/core';
import { ExtensionCommunicationService } from './services';

@NgModule({
  providers: [ExtensionCommunicationService],
})
export class ExtensionModule {}
